module.exports = __webpack_public_path__ + "static/media/youtube.ec1efab4.png";